import Link from "components/atoms/Link";
import React from "react";
import { mapMultiClassnames } from "utils/map-modifier";
import { isExternal } from "utils/utils-common";
import "./index.scss";

interface CardlinkProps {
  modifiers?: "smalllabel";
  image: React.ReactNode;
  label: string;
  href: any;
}

const CardLink: React.FC<CardlinkProps> = ({
  modifiers,
  image,
  label,
  href,
}: CardlinkProps) => (
  <div className={mapMultiClassnames("m-cardlink", modifiers)}>
    {image}

    <div className="m-cardlink_wrap">
      <div className="m-cardlink_title">{label}</div>
      <Link
        className="m-cardlink_wraplink"
        href={href}
        target={Boolean(isExternal(href))}
      >
        <span className="m-cardlink_label">XEM NGAY</span>
      </Link>
    </div>
  </div>
);

export default CardLink;
